export default "__VITE_ASSET__DWxixM32__"